import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);
export function $lang(...argArr) {
    const key = argArr[0];
    const args = argArr.slice(1);
    return u.__(key, args);
}
export function dateFormat(date, format = 'YYYY-MM-DD', useUtc = false) {
    if (useUtc) {
        return dayjs.utc(date).format(format);
    }
    return dayjs(date).format(format);
}
// 店家時段一律「台北牆上時間」。來源字串帶 +08:00，強制以 +08:00（480 分）顯示，
// 不受瀏覽器/裝置時區影響（例如國外客把裝置切到 UTC+14 也不會偏移）。
export function dateFormatTaipei(date, format = 'HH:mm') {
    return dayjs(date).utcOffset(480).format(format);
}
// 「台北牆鐘」的當下（dayjs 物件，已固定 +08:00 偏移）。
// 用於日曆 minDate/maxDate/今天：國外裝置（UTC-12、UTC+14…）的「今天」可能與台灣差一天，
// 訂位可選日一律以台灣日期為準，才能對齊伺服器回的可訂日。
export function taipeiNow() {
    return dayjs().utcOffset(480);
}
export function priceFormat(num) {
    let price = Number(num);
    let negative = price < 0;
    price = Math.abs(price);
    let formatted = numberFormat(price);
    formatted = '$' + ' ' + formatted;
    if (negative) {
        return '-' + formatted;
    }
    return formatted;
}
function numberFormat(number, decimals = 0, decPoint = '.', thousandsSep = ',') {
    number = Number(number);
    const str = number.toFixed(decimals ? decimals : 0).toString().split('.');
    const parts = [];
    for (let i = str[0].length; i > 0; i -= 3) {
        parts.unshift(str[0].substring(Math.max(0, i - 3), i));
    }
    str[0] = parts.join(thousandsSep ? thousandsSep : ',');
    return str.join(decPoint ? decPoint : '.');
}
export function viewSleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}
